import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/dashboard/[id]/measure-center/page";

export const Route = createFileRoute(
  "/clients/$clientId/dashboard/measure-center",
)({
  component: Page,
});
